import request from '@/utils/request'

let TaskApi = {
  /*列表*/
   taskList(data) {
    return request._post('/shop/plus.quest.task/index', data);
  },
  /*添加*/
  addTask(data) {
    return request._post('/shop/plus.quest.task/add', data);
  },
  /*获取数据*/
  getTask(data) {
    return request._get('/shop/plus.quest.task/edit', data);
  },

  /*保存*/
  saveTask(data) {
    console.log(data)
    return request._post('/shop/plus.quest.task/edit', data);
  },
  /*删除*/
  delTask(data) {
    return request._post('/shop/plus.quest.task/delete', data);
  },

}
export default TaskApi;



// WEBPACK FOOTER //
// ./src/api/task.js